var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup133(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(-31 -2658)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 76,
    height: 75,
    rx: 10,
    transform: "translate(31 2658)",
    fill: "#ffefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "megaphone",
    d: "M48.96,34.059a2.129,2.129,0,0,1-.949-.223l-4.257-2.129a2.13,2.13,0,1,1,1.9-3.81l4.257,2.129a2.129,2.129,0,0,1-.954,4.034ZM45.654,14.688l4.257-2.129a2.13,2.13,0,1,0-1.9-3.81l-4.257,2.129a2.13,2.13,0,1,0,1.9,3.81Zm5.435,6.6a2.129,2.129,0,0,0-2.129-2.129H44.7a2.129,2.129,0,1,0,0,4.257H48.96A2.129,2.129,0,0,0,51.088,21.287ZM38.316,40.445V2.129a2.129,2.129,0,0,0-4.257,0c0,6.277-5.5,8.515-10.643,8.515H8.515A8.515,8.515,0,0,0,0,19.158v4.257A8.515,8.515,0,0,0,8.515,31.93h14.9c5.145,0,10.643,2.237,10.643,8.515a2.129,2.129,0,0,0,4.257,0ZM17.425,36.188H8.515a12.772,12.772,0,0,1-2.942-.355l5.322,11.882a5.686,5.686,0,0,0,5.194,3.374A5.241,5.241,0,0,0,20.861,43.7Z",
    transform: "translate(44.455 2670.456)",
    fill: "#f55"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup133);
export default __webpack_public_path__ + "static/media/Group 133.5e8b7f75737ca269435f7f2a1bbd1ccf.svg";
export { ForwardRef as ReactComponent };